import { Component } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { MatDialog } from '@angular/material';
import { generalService } from '../../services/general.service';

@Component ({
  selector: 'salida-almacen-component',
  templateUrl: 'salida-almacen.component.html',
  providers: [generalService]
})

export class SalidaAlmacenComponent {
  constructor(public dataService: DataService,
              public dialog: MatDialog  ){ }

  ngOnInit() { }

}






// WEBPACK FOOTER //
// ./src/app/almacen/salidas/salida-almacen.component.ts